'use strict';

import angular from 'angular';
import modalTemplate from '../../app/grpRole/modal/modal.pug';

const ModalSvc = ['$rootScope', '$uibModal', function($rootScope, $uibModal) {
  /**
   * Opens a modal
   * @param  {Object} scope         - an object to be merged with modal's scope
   * @param  {String} modalOptions  - (optional) options to be applied to modal
   * @return {Object}               - the instance $uibModal.open() returns
   */
  function open(scope = {}, modalOptions = {}) {
    modalOptions.template = modalOptions.template
      || modalTemplate;
    modalOptions.modalClass = modalOptions.modalCall || 'modal-default';

    var modalScope = $rootScope.$new();
    modalOptions.scope = angular.extend(modalScope, scope);

    return $uibModal.open(modalOptions);
  }

  // Public API here
  return {
    open
  };
}];

export default ModalSvc;

/**
 * For reference - original modal configuration
 */
// /* Confirmation modals */
// confirm: {
//
//   /**
//    * Create a function to open a delete confirmation modal
//    * (ex. ng-click='myModalFn(name, arg1, arg2...)')
//    * @param  {Function} del - callback, ran when delete is confirmed
//    * @return {Function}     - the function to open the modal (ex. myModalFn)
//    */
//   delete(del = angular.noop) {
//     /**
//      * Open a delete confirmation modal
//      * @param  {String} name   - name or info to show on modal
//      * @param  {All}           - any additional args passed to del callback
//      */
//     return function() {
//       // eslint-disable-next-line prefer-rest-params
//       var args = Array.prototype.slice.call(arguments);
//       var name = args.shift();
//       var deleteModal;
//
//       deleteModal = openModal({
//         modal: {
//           dismissable: true,
//           title: 'Confirm Delete',
//           html: '<p>Are you sure you want to delete <strong>'
//             + name + '</strong> ?</p>',
//           buttons: [{
//             classes: 'btn-danger',
//             text: 'Delete',
//             click(e) {
//               deleteModal.close(e);
//             }
//           }, {
//             classes: 'btn-default',
//             text: 'Cancel',
//             click(e) {
//               deleteModal.dismiss(e);
//             }
//           }]
//         }
//       }, 'modal-danger');
//
//       deleteModal.result.then(function(event) {
//         del.apply(event, args);
//       });
//     };
//   }
// }
